// @flow @format
import CoreLayout from '../layouts/CoreLayout';
import LoginRoute from './Login';
import ExplorerRoute from './Explorer';

import type {Store} from 'redux';
import type {State} from '../reducers';

const makeRoutes = (store: Store<*, *>) => ({
	path: '/',
	onEnter: (nextState: Object, replace: (path: string) => void) => {
		const state: State = store.getState();

		if (
			!state.session.isLoggedIn &&
			nextState.location.pathname !== '/login'
		) {
			return replace('/login');
		}

		if (state.session.isLoggedIn && nextState.location.pathname === '/') {
			return replace('/explorer');
		}
	},
	component: CoreLayout,
	childRoutes: [LoginRoute(), ExplorerRoute(store)],
});

export default makeRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js